import React, { ReactElement } from 'react';
import { IDetailCardProps } from './DetailCard';
import css from './DetailCards.module.scss';

export interface IProps {
    children: Array<ReactElement<IDetailCardProps> | undefined | false>;
}

export const DetailCardList = React.memo<IProps>((props) => (
    <div className={css.detailCardList}>
        {React.Children.map(props.children, (detailCard, index) => (
            <div className={css.listCard} key={index}>
                {detailCard}
            </div>
        ))}
    </div>
));
